// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__Kj12F","logo__image":"Logo_logo__image__tGj_O","logo__brand":"Logo_logo__brand__ZMLcR"};